export default __webpack_public_path__ + "static/which-current-accounts-nov-2024-6438786cb3e22cc26507272fe5faa978.png";